export function chartTheme(isDark: boolean) {
  return {
    tick: isDark ? "hsl(215 20.2% 65.1%)" : "hsl(215.4 16.3% 46.9%)",
    grid: isDark ? "hsl(217.2 32.6% 17.5%)" : "hsl(214.3 31.8% 91.4%)",
    pieStroke: isDark ? "hsl(222.2 84% 4.9%)" : "hsl(210 40% 98%)",
    tooltip: {
      backgroundColor: isDark ? "hsl(222.2 47.4% 11.2%)" : "hsl(0 0% 100%)",
      border: isDark ? "1px solid hsl(217.2 32.6% 17.5%)" : "1px solid hsl(214.3 31.8% 91.4%)",
      color: isDark ? "hsl(210 40% 98%)" : "hsl(222.2 47.4% 11.2%)",
    },
  };
}

export function chartTooltipProps(isDark: boolean) {
  const { tooltip } = chartTheme(isDark);

  return {
    contentStyle: {
      backgroundColor: tooltip.backgroundColor,
      border: tooltip.border,
      borderRadius: 8,
      color: tooltip.color,
    },
    labelStyle: { color: tooltip.color },
    itemStyle: { color: tooltip.color },
  };
}
